export const FUNNEL_LOG_PAGE_TYPE = 'logged_in_homepage';
export const COURSE_RECOMMENDATIONS_SECTION_ID = 'course-recommendations-section';
export const MY_COURSES_HOME_URL = '/home/my-courses/';
export const PERSONAL_PLAN_HOME_URL = '/personal/home/';
export const BILLBOARD_NOTICE_TYPE = 'banner_carousel_slide';
export const BILLBOARD_NOTICE_TYPE_FOR_EVENTING = 'web_carousel_slide';
export const CERT_BUNDLE_DISCOUNT_CODE = 'BUNDLE_COUPON';
